import 'projects/sharedComponents/src/breedSummary/breedSummaryBars.scss';

import { BreedSummaryBarsFragment, ProductType } from 'projects/sharedComponents/src/generated/graphql-client-types';

import { BreedSummaryBar } from 'projects/sharedComponents/src/breedSummary/breedSummaryBar';
import { FC } from 'react';
import { Typography } from '@mui/material';

type BreedSummaryBarsProps = {
  dog: BreedSummaryBarsFragment;
};

export const BreedSummaryBars: FC<BreedSummaryBarsProps> = ({ dog }) => {
  const isPurebredKit = dog.swabSummary.productType === ProductType.Purebred;
  return (
    <>
      {dog.genotype?.breedMix.map((breed) => {
        return (
          <div key={breed.colorIndex}>
            <Typography>
              {breed.displayBreedPercent} {breed.breedName}
            </Typography>
            <BreedSummaryBar
              colorIndex={breed.colorIndex}
              width={breed.barWidthPercentage}
              isPurebredKit={isPurebredKit}
            />
          </div>
        );
      })}
    </>
  );
};
